import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Snackbar, Alert } from '@mui/material';
import { dialogActionsStyle, primaryButtonStyle, secondaryButtonStyle } from '../../utils/sharedStyles';

const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  errorMessage,
  showError,
  onCloseError,
  // Optional detail under the question, e.g. what else the deletion affects.
  children,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>
          {title}
        </DialogTitle>
        {children && <DialogContent>{children}</DialogContent>}
        <DialogActions style={dialogActionsStyle}>
          <Button
            style={secondaryButtonStyle}
            onClick={onClose}
            disabled={isDeleting}
          >
            ביטול
          </Button>
          <Button
            style={{ ...primaryButtonStyle, backgroundColor: '#F77389' }}
            onClick={handleDelete}
            color="error"
            disabled={isDeleting}
          >
            {isDeleting ? 'מוחק...' : 'מחק'}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={showError}
        autoHideDuration={6000}
        onClose={onCloseError}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={onCloseError}
          severity="error"
          variant="filled"
          sx={{ direction: 'rtl' }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DeleteConfirmationDialog;